<template>
	<div
		class="std-checkbox"
		:data-valid="valid"
	>
		<div class="std-checkbox-control">
			<input
				class="std-checkbox-original-control"
				:id="checkboxId"
				v-model="selected"
				type="checkbox"
				:required="required"
				@blur="handleBlur"
				@input="$emit('selected', !selected)"
			>
			<div class="std-checkbox-fake-control" />
		</div>

		<label
			:for="checkboxId"
			class="std-checkbox-label"
			v-html="labelText"
		/>

		<p
			v-if="!valid && error"
			class="std-checkbox-error-msg error-text"
			v-html="error"
		/>
	</div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { requiredIf } from '@vuelidate/validators';
import { createUUID } from '~/lib/utils';

export default {
	props: {
		required: {
			type: Boolean,
			default: false,
		},
		labelText: {
			type: String,
			default: '',
		},
		type: {
			type: String,
			default: 'text',
		},
		error: String
	},
	emits: ['selected'],
	data() {
		return {
			selected: false,
			v$: useVuelidate(),
		};
	},
	computed: {
		checkboxId() {
			return createUUID();
		},
		valid() {
			return !this.v$.selected.$dirty
				|| !this.required
				|| this.selected;
		}
	},
	methods: {
		handleBlur() {
			this.v$.selected.$dirty = true;
		},
	},
	validations() {
		return {
			selected: {
				required: requiredIf(this.required),
			},
		};
	},
};

</script>
